import axios from 'axios';
import { useEffect, useState } from 'react';
import Button from '../../../components/bootstrap/Button';
import Modal, {
	ModalBody,
	ModalFooter,
	ModalHeader,
	ModalTitle,
} from '../../../components/bootstrap/Modal';

const SPCallback = () => {
	const [isOpen, setIsOpen] = useState(false);
	const [isResponseOpen, setIsResponseOpen] = useState(false);
	const [responseData, setResponseData] = useState('');

	const copyToClipboard = async (text: string) => {
		if (navigator.clipboard?.writeText) {
			await navigator.clipboard.writeText(text);
			return;
		}

		const textarea = document.createElement('textarea');
		textarea.value = text;
		document.body.appendChild(textarea);
		textarea.select();
		document.execCommand('copy');
		document.body.removeChild(textarea);
	};

	const handleCloseResponse = async () => {
		try {
			if (responseData) {
				await copyToClipboard(responseData);
			}
		} finally {
			setIsResponseOpen(false);
		}
	};

	const handleGetAccessToken = () => {
		setIsOpen(false);
		const urlParams = new URLSearchParams(window.location.search);
		const oauthCode = urlParams.get('spapi_oauth_code');
		const params = new URLSearchParams();
		params.append('grant_type', 'authorization_code');
		params.append('code', oauthCode || '');
		params.append('redirect_uri', process.env.REACT_APP_AMAZON_CALLBACK_URI || '');
		params.append('client_id', process.env.REACT_APP_AMAZON_CLIENT_ID || '');
		params.append('client_secret', process.env.REACT_APP_AMAZON_CLIENT_SECRET || '');
		axios
			.post('https://api.amazon.com/auth/o2/token', params, {
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
				},
			})
			.then((res) => {
				setResponseData(JSON.stringify(res.data, null, 2));
				setIsResponseOpen(true);
			})
			.catch((err) => {
				console.log(err);
			});
	};

	useEffect(() => {
		setIsOpen(true);

		// }
	}, []);

	return (
		<div>
			<Modal
				title='SPCallback'
				isOpen={isOpen}
				setIsOpen={setIsOpen}
				isAnimation={false}
				isStaticBackdrop>
				<ModalHeader>
					<ModalTitle id='auth-confirm'>Amazon Authentication Complete</ModalTitle>
				</ModalHeader>
				<ModalBody>
					Amazon account connected successfully. Your store data will now sync
					automatically.
				</ModalBody>
				<ModalFooter>
					<Button icon='Check' color='success' onClick={() => handleGetAccessToken()}>
						Get Token
					</Button>
				</ModalFooter>
			</Modal>
			<Modal
				title='SPCallbackResponse'
				isOpen={isResponseOpen}
				setIsOpen={setIsResponseOpen}
				isAnimation={false}
				isStaticBackdrop
				isScrollable>
				<ModalHeader setIsOpen={setIsResponseOpen}>
					<ModalTitle id='auth-response'>Amazon Token Response</ModalTitle>
				</ModalHeader>
				<ModalBody>
					<pre className='mb-0 text-break' style={{ whiteSpace: 'pre-wrap' }}>
						{responseData}
					</pre>
				</ModalBody>
				<ModalFooter>
					<Button
						icon='ContentCopy'
						color='success'
						onClick={() => handleCloseResponse()}>
						Save & Close
					</Button>
				</ModalFooter>
			</Modal>
		</div>
	);
};
export default SPCallback;
